import { useMemo } from 'react';

import STORAGE_KEYS from '@/configs/local-storage-keys';
import useWorkspaceStorage from '@/hooks/pure/useWorkspaceStorage';

const useFeedbackListShowOptions = () => {
  const [showChart, setShowChart] = useWorkspaceStorage(
    STORAGE_KEYS.SHOW_CHART,
    true,
  );
  const [showFeedbackCount, setShowFeedbackCount] = useWorkspaceStorage(
    STORAGE_KEYS.SHOW_FEEDBACK_COUNT,
    false,
  );

  const state = useMemo(() => {
    return {
      showChart,
      showFeedbackCount,
    };
  }, [showChart, showFeedbackCount]);

  const setOption = (target: keyof typeof state, value: boolean) => {
    if (target === 'showChart') return setShowChart(value);
    if (target === 'showFeedbackCount') return setShowFeedbackCount(value);
  };

  return {
    showOptions: state,
    setOption,
  };
};

export default useFeedbackListShowOptions;
